// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"7fe52898","48":"6c346917","86":"bd7aca43","383":"823c5120","774":"c71d3dae"}[chunkId] + ".chunk.css";
};